
import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

import { isAvatarSrc, thumbnailMediumBlue } from '@utils/thumbnails'
import ProfileNavigateAvatar from '@elements/ProfileNavigateAvatar'
import { GreyedTextStyles } from './DrawerLayout'

// DRAWER AVATAR GROUP
const AvatarGroup = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  padding-bottom: ${size(1)};
  padding-top: ${size(1.5)};
  gap: ${size(1.5)};
`

const AvatarItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${size(0.75)};
  font-size: ${fontSize('xs')};
  ${GreyedTextStyles}
`

const DrawerAvatarGroup = ({ user }) => {
  const isNearbyAvatar = isAvatarSrc('medium', user?.nearbyMedia?.thumbnails?.[0], user?.defaultAvatar)
  const isSocialAvatar = isAvatarSrc('medium', user?.socialMedia?.thumbnail, user?.defaultAvatar)
  const renderNearby = user?.nearbyUuid
  const renderSocial = !user?.isAnonymous && user?.uuid

  return (
    <AvatarGroup>
      {renderNearby &&
        <AvatarItem>
          <ProfileNavigateAvatar
            replace
            userStatus={user?.tempStatus}
            statusSize={2.8}
            src={thumbnailMediumBlue(user?.nearbyMedia?.thumbnails?.[0], user?.defaultAvatar)}
            uuid={user?.nearbyUuid}
            style={{ height: size(8), width: size(8), borderRadius: '100px', flexShrink: 0, filter: isNearbyAvatar && 'grayscale(100%) contrast(120%) brightness(65%)' }}
          />
          nearby
        </AvatarItem>
      }
      {renderSocial &&
        <AvatarItem>
          <ProfileNavigateAvatar
            replace
            src={thumbnailMediumBlue(user?.socialMedia?.thumbnail, user?.defaultAvatar)}
            uuid={user?.uuid}
            toNearby={false}
            style={{ height: size(8), width: size(8), borderRadius: '100px', flexShrink: 0, filter: isSocialAvatar && 'grayscale(100%) contrast(120%) brightness(65%)' }}
          />
          social
        </AvatarItem>
      }
    </AvatarGroup>
  )
}

export { DrawerAvatarGroup }
